import React from 'react'
// import style from '../../style.module.less'
// import {Link} from 'react-router'
const From_TYPE = {
  '1': '线上充值',
  '2': '线下充值'
}

const STATUS = {
  '1': '充值成功',
  '2': '充值失败'
}

export default [
  {
    title: '流水号',
    dataIndex: 'entityId',
    key: 'entityId'
  },
  {
    title: '充值日期',
    dataIndex: 'createdAt',
    key: 'createdAt'
  },
  {
    title: '充值金额',
    dataIndex: 'value',
    key: 'value'
  },
  {
    title: '支付方式',
    dataIndex: 'fromType',
    key: 'fromType',
    render: (text, record) => {
      return <div>{From_TYPE[text]}</div>
    }
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    render: (text, record) => {
      return <div>{STATUS[text]}</div>
    }
  }
]
